import React from 'react';
import { Grid, GridProps, SvgIconProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import SettingItem from './SettingItem';

const StyledGrid = styled(Grid)(() => ({
  listStyle: 'none',
})) as typeof Grid;

interface IProps {
  colSpan: GridProps['xs'];
  icon: React.ElementType<SvgIconProps>;
  primaryText: React.ReactNode;
  secondaryText: React.ReactNode;
}

const TourSettingItem = (props: IProps) => {
  return (
    <StyledGrid component={'li'} item xs={props.colSpan}>
      <SettingItem icon={props.icon} primaryText={props.primaryText} secondaryText={props.secondaryText} />
    </StyledGrid>
  );
};

export type TourSettingItemProps = IProps;

export default TourSettingItem;
